module.exports = __webpack_public_path__ + "static/cris-2a0a791dc414219a3c15b43bdb574c7f.png";